import { render, staticRenderFns } from "./SizeFields.vue?vue&type=template&id=ad35771a&lang=pug&"
import script from "./SizeFields.vue?vue&type=script&lang=js&"
export * from "./SizeFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports